import React, { useEffect, useMemo, useState } from 'react';
import { useAtom } from 'jotai/index';
import classNames from 'classnames';
import styles from './css/index.module.scss';
import {
  configuratorCurrentLayersWidthsAtom,
  configuratorLayersListSizesAtom,
  draggedLayerNewIndexAtom, draggedLayerStartXAtom,
} from '../../../../atoms/configuratorAtoms';
import { MATERIALS_IDS, MATERIALS_INFO } from '../../../../constants/configurator';

const BAR_WIDTH = 4;

function ConfiguratorNewLayerBar() {
  const [draggedLayerNewIndex] = useAtom(draggedLayerNewIndexAtom);
  const [draggedLayerStartX] = useAtom(draggedLayerStartXAtom);
  const [configuratorLayersListSizes] = useAtom(configuratorLayersListSizesAtom);
  const [configuratorCurrentLayersWidths] = useAtom(configuratorCurrentLayersWidthsAtom);

  const isVisible = useMemo(() => draggedLayerNewIndex !== null, [draggedLayerNewIndex]);

  const [transformX, setTransformX] = useState(0);
  const [width, setWidth] = useState(BAR_WIDTH);
  const [isMissingComponentPosition, setIsMissingComponentPosition] = useState(false);

  useEffect(() => {
    if (!isVisible) {
      setWidth(BAR_WIDTH);
      setIsMissingComponentPosition(false);
      return setTransformX(configuratorLayersListSizes?.width ? configuratorLayersListSizes.width / 2 : 0);
    }

    const rightLayerWidth = configuratorCurrentLayersWidths[draggedLayerNewIndex];
    const leftLayerWidth = configuratorCurrentLayersWidths[draggedLayerNewIndex - 1];

    if (leftLayerWidth?.rightAdditionalWidth) {
      const missingComponentSizes = MATERIALS_INFO[MATERIALS_IDS.missingComponent];
      setWidth(missingComponentSizes.layerBodyWidth);
      setIsMissingComponentPosition(true);
      const margin = (missingComponentSizes.fullContainerWidth - missingComponentSizes.layerBodyWidth) / 2;
      return setTransformX(draggedLayerStartX - leftLayerWidth.rightAdditionalWidth + margin);
    }

    if (rightLayerWidth?.leftAdditionalWidth) {
      const missingComponentSizes = MATERIALS_INFO[MATERIALS_IDS.missingComponent];
      setWidth(missingComponentSizes.layerBodyWidth);
      setIsMissingComponentPosition(true);
      const margin = (missingComponentSizes.fullContainerWidth - missingComponentSizes.layerBodyWidth) / 2;
      return setTransformX(draggedLayerStartX + margin);
    }

    setWidth(BAR_WIDTH);
    setIsMissingComponentPosition(false);
    return setTransformX(draggedLayerStartX - BAR_WIDTH / 2);
  }, [isVisible, draggedLayerStartX, configuratorLayersListSizes, configuratorCurrentLayersWidths, draggedLayerNewIndex]);

  return (
    <div
      className={classNames(
        styles.newLayerBar,
        { [styles.visible]: isVisible },
        { [styles.isMissingComponentPosition]: isMissingComponentPosition },
      )}
      style={{
        transform: `translateX(${transformX}px)`,
        width: `${width}px`,
      }}
    />
  );
}

export default ConfiguratorNewLayerBar;
